import React from 'react';
import { Reveal } from '../Reveal';
import { Eyebrow } from './SectionBand';
const groups = [{
  title: 'Get in the room',
  line: 'Podcasts, interviews, speaking and content.'
}, {
  title: 'Continue the conversation',
  line: 'Follow-up, clearer calls to action and stronger sales conversations.'
}, {
  title: 'Connect people to the right work',
  line: 'Coaching, consulting, training, workshops, courses, certification, communities and more.',
  emphasize: true
}];

/**
 * Simplified editorial business-payoff — three forms of author leverage.
 * Resting state is fully opaque for contrast (no faded/disabled look).
 */
export function BusinessPayoffV2() {
  return <section className="bg-[#1a2838] px-6 pb-12 pt-10 text-[#faf8f5] md:px-10 md:pb-14 md:pt-12" data-id="element-647" data-mp="1pgxyl22d8bft">
      <div className="mx-auto max-w-5xl" data-id="element-648" data-mp="1lfuokw7019mi">
        <div className="max-w-3xl" data-id="element-649" data-mp="e0zl8m05n38s">
          <Reveal data-id="element-650" data-mp="dxtw56rj01d2">
            <Eyebrow data-id="element-651" data-mp="9ycp48wgaw5s">Author leverage</Eyebrow>
            <h2 className="mt-3 font-serif text-3xl leading-[1.12] text-[#faf8f5] md:text-5xl" data-id="element-652" data-mp="9xa3oghwdlx9">
              <span className="block" data-id="element-653" data-mp="2fnui6162y4pj">Your book creates authority.</span>
              <span className="mt-1.5 block italic text-[#a8c4bb]" data-id="element-654" data-mp="2kmfhzzhf6mdg">
                A Reader-to-Revenue path turns it into leverage.
              </span>
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-[#faf8f5]/95" data-id="element-655" data-mp="26oh4sxeu4vzj">
              Without that path, even interested readers can finish the book and
              disappear. You never learn what landed, what they need, or where
              they fit in the work behind your book.
            </p>
            <p className="mt-4 text-lg leading-relaxed text-[#faf8f5]/95" data-id="element-656" data-mp="21ouv2xy7txvh">
              We build the path that turns reader interest into action, useful
              context and better-fit business opportunity.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.05} data-id="element-657" data-mp="1dys5qplor60k">
          <div className="mt-10 divide-y divide-white/15 border-y border-white/15" data-id="element-658" data-mp="1dztegnf8bgf4">
            {groups.map(g => <div key={g.title} className={`py-5 md:grid md:grid-cols-[minmax(0,16rem)_1fr] md:items-baseline md:gap-10 md:py-6 ${g.emphasize ? 'md:py-7' : ''}`} data-id="element-659" data-mp="1iyd0soxqiu80">
                <h3 className={`font-serif leading-snug ${g.emphasize ? 'text-2xl text-[#d4a574] md:text-3xl' : 'text-xl text-[#faf8f5] md:text-2xl'}`} data-id="element-660" data-mp="3ftg3owbguy3s">
                  {g.title}
                </h3>
                <p className="mt-2 text-base leading-relaxed text-[#faf8f5]/95 md:mt-0 md:text-lg" data-id="element-661" data-mp="36vw0hhu1mrqj">
                  {g.line}
                </p>
              </div>)}
          </div>
        </Reveal>

        <Reveal delay={0.08} data-id="element-662" data-mp="2gmh46kacjvm">
          <p className="mx-auto mt-10 max-w-3xl text-center font-serif text-2xl leading-snug text-[#faf8f5] md:text-3xl" data-id="element-663" data-mp="2ea2o3dqkrnb">
            That is the opportunity.
            <br data-id="element-664" data-mp="3pk10ce7kxsk2" />
            <span className="italic text-[#a8c4bb]" data-id="element-665" data-mp="3pkj5y1g4tj4n">
              But it is probably not what is happening now.
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}